import ChangePin from '../../../../banking/components/cards/ChangePin';

export default function ChangePinPage() {
    return <ChangePin />;
}
